import { usePaginatedQuery } from 'react-query';
import { listCenters } from 'src/services/api/centers';

function useListCenters(query, enabled = true) {
  return usePaginatedQuery(['centers', query], (key, query) => listCenters(query), { enabled });
}

export default useListCenters;
